import { useQuery } from '@tanstack/react-query';
import { candidateAppService } from '../services/candidate-app.service';
import { useCandidateSession } from '../context/CandidateSessionContext';

export function useCandidateProfile(): {
  profile: ReturnType<typeof candidateAppService.getCandidateProfile> extends Promise<infer T>
    ? T | undefined
    : never;
  isLoading: boolean;
  isError: boolean;
  error: Error | null;
} {
  const { isAnonymous, shareId } = useCandidateSession();

  const query = useQuery({
    queryKey: isAnonymous ? ['candidate-profile', 'anonymous', shareId] : ['candidate-profile'],
    queryFn: () =>
      isAnonymous
        ? candidateAppService.getProfileByShareId(shareId!)
        : candidateAppService.getCandidateProfile(),
    staleTime: 5 * 60 * 1000, // 5 minutes
  });

  return {
    profile: query.data,
    isLoading: query.isLoading,
    isError: query.isError,
    error: query.error,
  };
}
